import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountConfig } from '../models/account-config.model';
import { SdkBase } from '../utilities/sdk-base/sdk.base';

@Injectable({
	providedIn: 'root'
})
export class AccountConfigSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getAccountConfigs(accountId: string): Observable<AccountConfig[]> {
		return this.makeHttpRequest<AccountConfig[]>('get', `api2/AccountConfigs/${accountId}`);
	}

	public updateAccountConfig(config: AccountConfig): Observable<void> {
		return this.makeHttpRequest<void>('put', `api2/AccountConfigs/${config.accountId}`, config);
	}
}
